import React, { useEffect, useState } from 'react'
import { formatNumbers, convertFromWei } from "../../../utils/helpers";
import { getDashBoardData } from "../../../utils/services";

const Tvl = () => {
  const [dashBoardStats, setDashBoardStats] = useState([])

  useEffect(() => {
    const dashboardStatsData = async () => {
      const dashBoardRes = await getDashBoardData()
      setDashBoardStats(dashBoardRes)
    }
    dashboardStatsData()
  }, [])

  return (
    <>
      <section className="main-tvl">
        <div className="custom-container">
          <div className="main-cards">
            <div className="one-card">
              <h2>
                <span className="yellowcolor"></span>Total Value Locked (TVL)
              </h2>
              <h3>${dashBoardStats?.tvl?.value ? formatNumbers(+convertFromWei(dashBoardStats?.tvl?.value, 'mwei')) : 0}</h3>
              <h4>
                {dashBoardStats?.tvl?.changePercent > 0 && (
                  <div style={{ background: "rgba(229, 254, 0, 0.10)", borderRadius: "50%" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <rect
                        x="9.61651e-07"
                        y="22"
                        width="22"
                        height="22"
                        rx="11"
                        transform="rotate(- 9.61651e-07 22)"
                        fill="#E5FE00"
                        fill-opacity="0.1"
                      />
                      <path
                        d="M11 16.5L11 5.5"
                        stroke="#E5FE00"
                        stroke-width="1.57143"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.5 11L11 5.5L16.5 11"
                        stroke="#E5FE00"
                        stroke-width="1.57143"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                )}
                {dashBoardStats?.tvl?.changePercent > 0 ? `${dashBoardStats.tvl.changePercent}%` : "0%"}
              </h4>
            </div>
            <div className="four-cards">
              <div className="innercardone">
                <h2>
                  <span className="yellowcolor"></span>Total Trading Volume
                </h2>
                <div className="inner-text">
                  <h3>${dashBoardStats?.totalTradingVolume?.value ? formatNumbers(+convertFromWei(dashBoardStats?.totalTradingVolume?.value, 'mwei')) : 0}</h3>
                  <h4>
                    {dashBoardStats?.totalTradingVolume?.changePercent !== 0 && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        transform={dashBoardStats?.totalTradingVolume?.changePercent > 0 ? "rotate(0)" : "rotate(180)"}
                      >
                        <rect
                          x="9.61651e-07"
                          y="22"
                          width="22"
                          height="22"
                          rx="11"
                          transform="rotate(-90 9.61651e-07 22)"
                          fill="#8559E3"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M11 16.5L11 5.5"
                          stroke="#8559E3"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.5 11L11 5.5L16.5 11"
                          stroke="#8559E3"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    {dashBoardStats?.totalTradingVolume?.changePercent ? `${dashBoardStats.totalTradingVolume.changePercent}%` : "0%"}
                  </h4>
                </div>
              </div>
              <div className="innercardtwo">
                <h2>
                  <span className="yellowcolor"></span>$RAIN Burned
                </h2>
                <div className="inner-text">
                  <h3>{dashBoardStats?.rainBurned?.value ? formatNumbers(+(dashBoardStats?.rainBurned?.value)) : 0}</h3>
                  <h4>
                    {dashBoardStats?.rainBurned?.changePercent !== 0 && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        transform={dashBoardStats?.rainBurned?.changePercent > 0 ? "rotate(0)" : "rotate(180)"}
                      >
                        <rect
                          x="9.61651e-07"
                          y="22"
                          width="22"
                          height="22"
                          rx="11"
                          transform="rotate(-90 9.61651e-07 22)"
                          fill="#FF5C32"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M11 16.5L11 5.5"
                          stroke="#FF5C32"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.5 11L11 5.5L16.5 11"
                          stroke="#FF5C32"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    {dashBoardStats?.rainBurned?.changePercent ? `${dashBoardStats.rainBurned.changePercent}%` : "0%"}
                  </h4>
                </div>
              </div>
              <div className="innercardthree">
                <h2>
                  <span className="yellowcolor"></span>On-chain Transactions
                </h2>
                <div className="inner-text">
                  <h3>{dashBoardStats?.onChainTransactions?.value ? formatNumbers(+dashBoardStats?.onChainTransactions?.value) : 0}</h3>
                  <h4>
                    {dashBoardStats?.onChainTransactions?.changePercent !== 0 && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        transform={dashBoardStats?.onChainTransactions?.changePercent > 0 ? "rotate(0)" : "rotate(180)"}
                      >
                        <rect
                          x="9.61651e-07"
                          y="22"
                          width="22"
                          height="22"
                          rx="11"
                          transform="rotate(-90 9.61651e-07 22)"
                          fill="#99FF80"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M11 16.5L11 5.5"
                          stroke="#99FF80"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.5 11L11 5.5L16.5 11"
                          stroke="#99FF80"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    {dashBoardStats?.onChainTransactions?.changePercent ? `${dashBoardStats.onChainTransactions.changePercent}%` : "0%"}
                  </h4>
                </div>
              </div>
              <div className="innercardfour">
                <h2>
                  <span className="yellowcolor"></span>Total Active Users
                </h2>
                <div className="inner-text">
                  <h3>{dashBoardStats?.totalActiveUsers?.value ? formatNumbers(+dashBoardStats?.totalActiveUsers?.value) : 0}</h3>
                  <h4>
                    {dashBoardStats?.totalActiveUsers?.changePercent !== 0 && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        transform={dashBoardStats?.totalActiveUsers?.changePercent > 0 ? "rotate(0)" : "rotate(180)"}
                      >
                        <rect
                          x="9.61651e-07"
                          y="22"
                          width="22"
                          height="22"
                          rx="11"
                          transform="rotate(-90 9.61651e-07 22)"
                          fill="#12AAFF"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M11 16.5L11 5.5"
                          stroke="#12AAFF"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.5 11L11 5.5L16.5 11"
                          stroke="#12AAFF"
                          stroke-width="1.57143"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    {dashBoardStats?.totalActiveUsers?.changePercent ? `${dashBoardStats.totalActiveUsers.changePercent}%` : "0%"}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="rain-top">
            Data powered by Rain API. Verified on
            <div className="homepagee">
              <a href="https://defillama.com/protocol/rain" target='_blank'><img src="\assets\homepage\banner\linkimg.svg" /></a>
              &
              <a href="https://dune.com/rain_predictions/rain" target='_blank'><img src="\assets\homepage\banner\dune.svg" /></a>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Tvl;
